
import React from "react";
import { IconButton, Typography } from '@mui/material';
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { useLazySearchEmailQuery } from "../../../api/userApiSlice";
import { useLazyGetSignedDucUrlByUsernameQuery } from "../../../api/ducApiSlice";


export const MakeHyperLink = (props: any) => {
    const [searchByEmail] = useLazySearchEmailQuery();
    const [getSignedUrlByUsername] = useLazyGetSignedDucUrlByUsernameQuery();

    const handleOpenSignedDoc = async () => {
        try {
            const row = props?.data || {};
            const piEmail = row?.leadRecipientEmail;
            const userEmail = row?.email;
            const isSubApplicant = piEmail && piEmail !== userEmail;

            // Determine the username whose DUC should be opened
            let targetUsername: string | undefined = row?.username;
            // Determine ducType to send to BE
            let ducType: string | undefined = row?.ducType;

            if (isSubApplicant) {
                // Prefer a direct PI username field if available
                targetUsername = row?.leadRecipientUsername || targetUsername;

                // If PI username not on the row, look it up by PI email
                if (!row?.leadRecipientUsername) {
                    const resp: any = await searchByEmail({ email: piEmail }).unwrap();
                    const allUsers = resp?.allUsers || [];
                    const piUser = allUsers.find((u: any) => u?.email === piEmail) || allUsers[0];
                    targetUsername = piUser?.username || targetUsername;
                    // If ducType is not set on row, try from PI user
                    ducType = ducType || piUser?.ducType;
                }
            }

            if (!targetUsername || !ducType) {
                // eslint-disable-next-line no-console
                console.warn('Missing username or ducType for signed DUC URL request', { targetUsername, ducType });
                return;
            }

            const data: any = await getSignedUrlByUsername({ username: targetUsername, ducType }).unwrap();
            const url = data?.url || data;
            if (url) {
                window.open(url, '_blank', 'noopener,noreferrer');
            }
        } catch (e) {
            // Fallback: do nothing or show console for now
            // eslint-disable-next-line no-console
            console.error('Failed to open DUC document URL', e);
        }
    };

    if(props.value === null || props.value === ""){
        return "";
    }
    else if(props.value === "NotSubmitted" && props?.data?.ducStatus === "DucExpired"){
        return "Duc Expired"
    }
    else if(props.value === "NotSubmitted" && props?.data?.ducStatus === "TrainingExpired"){
        return "Training Expired"
    }
    else if(props.value === "NotSubmitted"){
        return "No Duc process started";
    }
    else if(props.value === "Pending NIDA approval"){
        return (
            <Typography fontSize="13px" color="blueviolet" sx={{ textDecoration: 'underline' }}>
                {
                /* Following ticket is responsible for the discrepancy of NIDA and DAC:
                https://lassoinformatics.atlassian.net/browse/LC-2092
                */
                }
              Pending DAC approval
            </Typography>
        );
    }
    else if (props?.data?.ducStatus === "TrainingComplete"){
        return (
            <Typography
                role="link"
                tabIndex={0}
                onClick={handleOpenSignedDoc}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpenSignedDoc(); } }}
                fontSize="13px"
                color="primary"
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
                DUC and Training Complete
            </Typography>
        );
    }
    else if (props.value === "DUC Approved"){
        return (
            <Typography
                role="link"
                tabIndex={0}
                onClick={handleOpenSignedDoc}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpenSignedDoc(); } }}
                fontSize="13px"
                color="primary"
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
                DUC Approved
            </Typography>
        );
    }
    else if (props.value === "View Certificate"){
        // LC-221: Pending (Change Lead Investigator) tab, once the new PI's DUC is fully approved.
        return (
            <Typography
                role="link"
                tabIndex={0}
                onClick={handleOpenSignedDoc}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpenSignedDoc(); } }}
                fontSize="13px"
                color="primary"
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
                View Certificate
            </Typography>
        );
    }
    else{
        return props.value;
    }
}

export const checkGroup = (props: any) => {
    if(props.data.groupDuc){
        return "Investigator-led"
    }
    else{
        return "Individual"
    }

}


export const GetRevoked = (props: any) => {
    const row = props?.data
    return (
        <IconButton
            tabIndex={-1} //Prevents focus trap. User will be tabbing/arrow keying cells in aggrid.
            disabled={row?.ducStatus === 'NotSubmitted'}
            aria-label={`Revoke DUC for ${row?.email}`}
            aria-disabled={row?.ducStatus === 'NotSubmitted'}
        >
            <DeleteForeverOutlinedIcon/>
        </IconButton>
    )
}